"use client";

import { Button } from "@/components/ui/button";
import { Copy, LoaderCircle } from "lucide-react";
import { GetLomdaV3ResponseType } from "../../hooks/useGetLomdaV3";
import { useState } from "react";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { useQueryClient } from "@tanstack/react-query";
import { t } from "@/lib/localization";

export default function DuplicateLomdaV3Button({
    lomda,
}: {
    lomda: GetLomdaV3ResponseType["data"];
}) {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();

    const handleDuplicate = async () => {
        setLoading(true);

        try {
            const res = await client.api.storage["lomda-v3"].duplicate.$post({
                json: {
                    lomdaIdToCopy: lomda.id,
                    newName: t("lomda-sheet.duplicate.default-name", undefined, {
                        name: lomda.name ?? "",
                    }),
                },
            });

            if (!res.ok) {
                const errorData = await res.json();
                console.error("Error duplicating lomdaV3:", errorData);
                toast.error(t("toast.error.duplicate-lomda"), {
                    keyName: "toast.error.duplicate-lomda",
                });
                return;
            }

            await res.json();

            toast.success(t("toast.success.duplicate-lomda"), {
                keyName: "toast.success.duplicate-lomda",
            });

            queryClient.invalidateQueries({ queryKey: ["get-storage-files"] });
            queryClient.invalidateQueries({
                queryKey: ["get-storage-folders"],
            });
        } catch (error) {
            console.error("Error duplicating lomdaV3:", error);
            toast.error(t("toast.error.default"), {
                keyName: "toast.error.default",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleDuplicate}
            disabled={loading}
            variant="secondary"
            size="sm"
        >
            {loading ? (
                <LoaderCircle className="size-3.5 me-2 animate-spin" />
            ) : (
                <Copy className="size-3.5 me-2" />
            )}
            {t("lomda-sheet.header.duplicate-btn", undefined, undefined)}
        </Button>
    );
}
